<h1 mat-dialog-title>Vendor Webhook Event</h1>

<div mat-dialog-content>
  <form [formGroup]="form" class="form">
    <mat-form-field appearance="outline">
      <mat-label>Created</mat-label>
      <input matInput formControlName="createdAt">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Vendor</mat-label>
      <input matInput formControlName="vendor">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Product</mat-label>
      <input matInput formControlName="product">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Action</mat-label>
      <input matInput formControlName="action">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <input matInput formControlName="status">
    </mat-form-field>
    <mat-form-field appearance="outline" class="json-field">
      <mat-label>Payload JSON</mat-label>
      <app-json formControlName="payload" [readOnly]="true" baseTable="vendorWebhookLog" fieldHint="payload"></app-json>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions class="buttons">
  <button mat-raised-button color="primary" (click)="close()">Close</button>
</div>
